const EditeProduct = () => {
    return (
        <div className="EditeProduct">
            edit product
        </div>
    );
}

export default EditeProduct;